module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/slender-397717ff4b7a545541ed595e71ab42dd.jpg";